<template>
    <v-layout justify-center>
        <v-responsive max-width="1140px" width="100%" height="100%" class="px-1">
            <div class="headline text-start mt-8">
                <span>교육소개</span>
            </div>

            <section class="mt-4">
                <v-layout>
                    <span class="subtitle-2 font-weight-bold">유튜브 링크</span>
                </v-layout>
                <v-card>
                    <v-card-text class="d-flex">
                        <v-spacer/>
                        <v-btn small color="primary" @click="$set(festa.youtubeLink, festa.youtubeLink.length, {})"><v-icon left size="18">mdi-plus</v-icon>추가</v-btn>
                    </v-card-text>
                    <template v-for="item, index in festa.youtubeLink">
                        <v-divider :key="'divider' + index"/>
                        <v-row :key="index" align="center" class="px-4">
                            <v-col cols="10">
                                <v-textarea v-model="item.title" dense hide-details outlined rows="1" />
                            </v-col>
                            <v-col cols="auto">
                                <v-btn small outlined color="red" @click="festa.youtubeLink.splice(index, 1)"><v-icon size="18">mdi-delete-outline</v-icon>삭제</v-btn>
                            </v-col>
                        </v-row>
                    </template>
                </v-card>
            </section>

            <section class="mt-4">
                <v-layout>
                    <span class="subtitle-2 font-weight-bold">프로그램 및 커리큘럼</span>
                </v-layout>
                <v-card>
                    <v-card-text class="d-flex">
                        <v-spacer/>
                        <v-btn v-if="festa.section2.length < 4" small color="primary" @click="$set(festa.section2, festa.section2.length, {name: null, items:[], curriculums:[{subtitles: [ { items: [] } ]}], links: []})"><v-icon left size="18">mdi-plus</v-icon>추가</v-btn>
                    </v-card-text>
                    <template v-for="section, index in festa.section2">
                        <v-divider :key="'divider' + index"/>
                        <v-col :key="index" class="text-h6 font-weight-bold">프로그램</v-col>
                        <v-row :key="index" align="center" class="px-4">
                            <v-col cols="6">
                                <v-textarea v-model="section.name" placeholder="커리큘럼 명칭을 입력해주세요" dense hide-details outlined rows="1" />
                            </v-col>
                            <v-col cols="auto">
                                <v-btn small outlined color="red" @click="festa.section2.splice(index, 1)"><v-icon size="18">mdi-delete-outline</v-icon>삭제</v-btn>
                                <v-btn small color="primary" @click="$set(section.items, section.items.length, {})"><v-icon left size="18">mdi-plus</v-icon>프로그램 추가</v-btn>
                                <v-btn small color="primary" @click="$set(section.curriculums, section.curriculums.length, {})"><v-icon left size="18">mdi-plus</v-icon>커리큘럼 추가</v-btn>
                                <v-btn small color="primary" @click="$set(section.links, section.links.length, { title: null })"><v-icon left size="18">mdi-plus</v-icon>유튜브 링크 추가</v-btn>
                            </v-col>
                        </v-row>
                        <v-col :key="index" class="text-h6 font-weight-bold">프로그램 항목</v-col>
                        <template v-for="item, index1 in section.items">
                            <v-divider :key="'divider' + index1"/>
                            <v-row :key="index1" align="center" class="px-4">
                                <v-col cols="2">
                                    <v-textarea v-model="item.title" placeholder="프로그램 타이틀을 입력해주세요" dense hide-details outlined rows="1" />
                                </v-col>
                                <v-col>
                                    <v-textarea v-model="item.txt" placeholder="프로그램 내용을 입력해주세요" hide-details outlined rows="2" />
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn small outlined color="red" @click="section.items.splice(index1, 1)"><v-icon size="18">mdi-delete-outline</v-icon>삭제</v-btn>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-for="curriculum, index2 in section.curriculums">
                            <v-divider :key="'divider' + index2"/>
                            <v-col :key="index2" class="text-h6 font-weight-bold">커리큘럼 대제목</v-col>
                            <v-row :key="index2" align="center" class="px-4">
                                <v-col cols="8">
                                    <v-textarea v-model="curriculum.title" placeholder="대제목을 입력해주세요" dense hide-details outlined rows="1" />
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn small color="primary" @click="$set(curriculum.subtitles, curriculum.subtitles.length, {title: null, items: []})"><v-icon left size="18">mdi-plus</v-icon>소제목 추가</v-btn>
                                    <v-btn small outlined color="red" @click="section.curriculums.splice(index2, 1)"><v-icon size="18">mdi-delete-outline</v-icon>삭제</v-btn>
                                </v-col>
                            </v-row>
                            <template v-for="subtitle, index3 in curriculum.subtitles">
                                <v-divider :key="'divider' + index3"/>
                                <v-col :key="index3" class="text-h6 font-weight-bold">커리큘럼 소제목</v-col>
                                <v-row :key="index3" align="center" class="px-4">
                                    <v-col cols="8">
                                        <v-textarea v-model="subtitle.title" placeholder="소제목을 입력해주세요" dense hide-details outlined rows="1" />
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn small color="primary" @click="$set(subtitle.items, subtitle.items.length, {})"><v-icon left size="18">mdi-plus</v-icon>항목 추가</v-btn>
                                        <v-btn small outlined color="red" @click="curriculum.subtitles.splice(index3, 1)"><v-icon size="18">mdi-delete-outline</v-icon>삭제</v-btn>
                                    </v-col>
                                </v-row>
                                <v-col :key="index3" class="text-h6 font-weight-bold">커리큘럼 소제목 항목</v-col>
                                <template v-for="item, index4 in subtitle.items">
                                <v-divider :key="'divider' + index4"/>
                                <v-row :key="index4" align="center" class="px-4">
                                    <v-col cols="10">
                                        <v-textarea v-model="item.title" placeholder="소제목에 항목을 입력해주세요" dense hide-details outlined rows="1" />
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn small outlined color="red" @click="subtitle.items.splice(index4, 1)"><v-icon size="18">mdi-delete-outline</v-icon>삭제</v-btn>
                                    </v-col>
                                </v-row>
                            </template>
                            </template>
                            <template v-for="link, index in section.links">
                                <v-divider :key="'divider' + index"/>
                                <v-row :key="index" align="center" class="px-4">
                                    <v-col cols="10">
                                        <v-textarea v-model="link.title" placeholder="유튜브 링크를 입력해주세요" dense hide-details outlined rows="1" />
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn small outlined color="red" @click="section.links.splice(index, 1)"><v-icon size="18">mdi-delete-outline</v-icon>삭제</v-btn>
                                    </v-col>
                                </v-row>
                            </template>
                            <template>
                                <v-divider />
                                <v-row align="center" class="px-4">
                                    <v-col cols="10">
                                        <v-textarea v-model="section.link" placeholder="교육접수 링크를 입력해주세요" dense hide-details outlined rows="1" />
                                    </v-col>
                                    <v-col cols="auto">
                                      
                                    </v-col>
                                </v-row>
                            </template>
                        </template>
                    </template>
                </v-card>
            </section>

            <v-row justify="center" class="mx-1 my-4">
                <v-col md="auto" sm="auto">
                    <v-btn dark color="blue darken-2" elevation="4" @click="save()">저장</v-btn>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
export default {
    data() {
        return {
            festa: {

                youtubeLink: [],

                // section2: [
                //     {
                //         name: "데이터 분야",
                //         items: [
                //             { title: "교육목적", txt: "기술기업이 우통...." },
                //             { title: "교육목적", txt: "기술기업이 우통...." },
                //             { title: "교육목적", txt: "기술기업이 우통...." },
                //             { title: "교육목적", txt: "기술기업이 우통...." }
                //         ],
                //         curriculums: [
                //             { title: "온라인커멋, 플랫폼 종류별 특징과 트렌드(30분)", childs: [
                //                 { 
                //                     title: "온라인 커머스 트렌드", childs: [
                //                         { title: "온라인 쇼핑과 모바일 쇼핑 거래액" },
                //                         { title: "웹과 모바일쇼핑 동향조사" },
                //                         { title: "모바일로 더 편리해진 생활" },
                //                     ] 
                //                 },
                //             ] }
                //         ],
                //         links: [
                //             { title: "https://www.youtube.com/watch?v=6sBig5kccbE" }
                //         ]
                //     }
                // ],
                section2: [
                    {
                        name: null,
                        items: [
                            { title: null, txt: null },
                            { title: null, txt: null },
                            { title: null, txt: null },
                            { title: null, txt: null }
                        ],
                        curriculums: [
                            { title: null, subtitles: [ // 대제목
                                { 
                                    title: null, items: [ // 소제목
                                        { title: null }, // 소제목 항목
                                        { title: null },
                                        { title: null },
                                    ] 
                                },
                            ] }
                        ],
                        links: [
                            { title: null }
                        ],

                        link: null
                    }
                ],

                section3: {
                    table: {
                        list: []
                    }
                },
            },

        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init(){
            let { festa } = await api.console.education.festa.get();
            this.festa = festa ?? this.festa;
        },
        log(args){
            console.log({
                args
            });
        },
        async save(){
            await api.console.education.festa.put(this.festa);

            alert("저장되었습니다");
        },
        async upload(file, row, col){
            let { src } = await api.resource.post(file, "/res/education/festa");
            this.$set(this.festa.section6.contents.frame2302.logoList[row], col, { src, url: "" });
            this.$forceUpdate();
        },
        setCurriculum() {
            
            this.$set(this.festa.section2, this.festa.section2.length, {name: null, items:[], curriculums:[{subtitles: [ { items: [] } ]}], links: []})
        }
    },
};
</script>


